export const colors: {[key: string]: any} = {
  white: '#ffffffff',
  black: '#000000ff',
  primary: {
    '0': '#e9eaebff',
    '10': '#d2d4d7ff',
    '20': '#bcbfc3ff',
    '30': '#a5a9afff',
    '40': '#8f949bff',
    '50': '#797f87ff',
    '60': '#626973ff',
    '70': '#4c545fff',
    '80': '#353e4bff',
    base: '#1f2937ff',
    '100': '#1c2532ff',
    '110': '#19212cff',
    '120': '#161d27ff',
    '130': '#131921ff',
    '150': '#0c1016ff',
    '140': '#10151cff',
    '160': '#090c10ff',
    '170': '#06080bff',
    '180': '#030405ff'
  },
  secondary: {
    '0': '#fafafaff',
    '10': '#f5f5f5ff',
    '20': '#eeeeeeff',
    '30': '#e6e6e6ff',
    '40': '#ddddddff',
    '50': '#d5d5d5ff',
    base: '#ccccccff',
    '60': '#aaaaaaff',
    '70': '#888888ff',
    '80': '#666666ff',
    '90': '#444444',
    '95': '#292929ff',
    '100': '#141414ff'
  },
  warning: {
    contrastText: '#FFF8F8',
    light: '#DC3D43',
    main: '#DC3D43',
    dark: '#b03136'
  },
  accent: {
    orange_bright: '#f7ce00ff',
    orange_medium: '#FEF6D1ff',
    orange_soft: '#fffce8ff',
    green_bright: '#299764ff',
    green_medium: '#BFE0D1ff',
    green_soft: '#f2fcf5ff',
    blue_medium: '#CCE9FF',
    navy_medium: '#B2C2F3'
  },
  toast: {
    red: 'rgba(200, 41, 47, 0.88)',
    green: 'rgba(41, 151, 100, 0.88)'
  },
  orange: {
    50: '#F59E0B',
    60: '#C47E09',
    70: '#AC6F08',
    80: '#935F07',
    90: '#623F04',
    100: '#492F03',
    110: '#300E0E'
  },
  red: {
    20: '#F5C5C7',
    50: '#EF4444',
    60: '#782222',
    70: '#601B1B',
    80: '#481414',
    90: '#300E0E'
  },
  green: {
    50: '#10B981',
    60: '#085D41',
    70: '#064A34',
    80: '#053727',
    90: '#03251A'
  },
  blue: {
    50: '#3B82F6',
    60: '#234E94',
    70: '#1E417B',
    80: '#183462',
    90: '#12274A'
  },
  navy: {
    50: '#484C8B'
  },
  grey: {
    10: '#F5F5F5',
    20: '#EEE',
    50: '#6B7280',
    60: '#40444D',
    70: '#2B2E33',
    80: '#202226',
    90: '#15171A'
  },
  defaultWebshop: '#000066',
  tag: {
    bg: '#B2C2F3',
    text: '#484C8B'
  },
  button: {
    grey: '#CCCCCC3D'
  },
  border: {
    purple: '#B149E6'
  },
  skeletonGradient: 'linear-gradient(90deg, #FAFAFA 0%, #F5F5F5 100%)',
  arbitrageGradient: {
    circle1: '#D3CEEB',
    circle2:
      'radial-gradient(50% 50% at 50% 50%, hsla(250, 42%, 86%, 1) 0%, hsla(250, 42%, 86%, 0) 100%)'
  },
  withdrawalGradient:
    'linear-gradient(98deg, rgba(107, 47, 224, 0.04) -19.05%, rgba(173, 71, 230, 0.08) 110.05%)',
  withdrawalGradient2:
    'linear-gradient(96deg, rgba(177, 73, 230, 0.08) 0.11%, rgba(107, 47, 224, 0.08) 100.11%)',
  pendingCashbackGradient:
    'linear-gradient(98deg, rgba(224, 133, 47, 0.04) -19.05%, rgba(230, 158, 71, 0.08) 110.05%)'
};
